import { HireViewType, HydrateOption } from '@core/enums';
import withRedux from '@helpers/withRedux';
import withWidget from '@hoc/withWidget';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import HireCard from '@stories/Components/Cards/HireCard/HireCard';
import OrderProgressBar from '@stories/Components/Checkout/OrderProgressBar/OrderProgressBar';
import StyledSection from '@stories/Components/Containers/StyledSection/StyledSection';
import IntroductionContent from '@stories/Components/Content/IntroductionContent/IntroductionContent';
import React from 'react';
import { useSelector } from 'react-redux';
import { OrderOverviewStyles as S } from './OrderOverview.styles';
const OrderOverview = (props) => {
    const basket = useSelector((x) => x.basket);
    const app = useSelector((x) => x.app);
    const text = basket.basket && basket.basket.order && basket.basket.order.orderLines.length > 0
        ? props.text
        : props.translations['g42.checkout.emptybasket'];
    return (React.createElement(S.Wrapper, null,
        React.createElement(OrderProgressBar, { items: props.steps }),
        React.createElement(StyledSection, null,
            React.createElement(IntroductionContent, { title: props.title, text: text, centerText: true }),
            React.createElement(S.List, null, basket.basket?.order?.orderLines.map((x) => {
                return (React.createElement(HireCard, { key: x.productId, hire: {
                        id: x.productId,
                        quantity: x.quantity,
                        allowDelete: true,
                        variant: x.productName,
                        title: x.productGroupName,
                        imageUrl: x.productImageUrl,
                        price: x.ratePrice,
                        priceFormatted: x.ratePriceFormatted,
                        startDate: new Date(x.hireDateStart),
                        endDate: new Date(x.hireDateEnd),
                        hireViewType: HireViewType.Editable,
                        dayHirePeriodText: props.translations['g42.productdetail.dayhireperiodtext'],
                        priceSuffix: props.translations['g42.productdetails.pricesuffix.perweek'],
                        quantityLabel: props.translations['g42.productdetail.selectquantity'],
                        startDateLabel: props.translations['g42.productdetail.startdatelabel'],
                        endDateLabel: props.translations['g42.productdetail.enddatelabel'],
                        productQuestion: x.lineQuestions && x.lineQuestions.length > 0 ? x.lineQuestions[0] : '',
                    }, excludedDates: app.excludedDates }));
            })),
            basket.basket && basket.basket.order && basket.basket.order.orderLines.length > 0 ? (React.createElement(S.ButtonWrapper, null,
                React.createElement(LinkButton, { branding: "primary", title: props.buttonText, href: app.checkoutDetailsUrl }))) : null)));
};
export default withWidget(withRedux(OrderOverview), 'OrderOverview', {
    hydrate: HydrateOption.InView,
});
